export { DisplayOXXOBrand } from './display-oxxo-brand';
